var _linearGradient;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAhli(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397.7 114.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-51.2 -192.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.3,196.2a61.92,61.92,0,0,1,19.4,17,74.9,74.9,0,0,1,21.1-17Zm21.5,20a58.32,58.32,0,0,1,7.9,19.1c2.9-8.7,8.6-15.7,17.2-20.9l1.8-1.1,1.8,1.1c8.6,5.2,14.4,12.2,17.2,20.9a59.23,59.23,0,0,1,7.9-19.1c-9-10.9-20.8-17.3-27-20-6,2.8-17.8,9.1-26.8,20m34.9-20a77.81,77.81,0,0,1,21.1,17,61.92,61.92,0,0,1,19.4-17ZM420,215.9c-.7,1-1.4,2.1-2.1,3.2h0c-5.2,8.6-7.9,18.8-7.9,30.1V289a.43.43,0,0,1-.4.4H368a.43.43,0,0,1-.4-.4V249.2c0-11.3-2.7-21.5-7.9-30.1a29.22,29.22,0,0,0-2.1-3.2c-5.9-8.4-14.4-15.1-25.3-19.7v19.3a37.45,37.45,0,0,1,15.6,20.3,39.55,39.55,0,0,1,2,13v21.4c0,9.5-4,18.1-10.6,23h98.8c-6.6-4.9-10.6-13.5-10.6-23V248.8a39.55,39.55,0,0,1,2-13c2.6-8.3,7.9-15,15.7-20.3V196.2c-10.8,4.6-19.3,11.3-25.2,19.7",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -97.12,
    y1: -25.7,
    x2: -94.66,
    y2: -25.7,
    gradientTransform: "translate(1340.82 -3692.15) rotate(-90) scale(39.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#89c540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#89c540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#76b943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#46994b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#006a56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006a56"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M406.4,285.3a.46.46,0,0,1-.5.4H371.5a.43.43,0,0,1-.4-.4V249.1c0-15.5,7.2-25.4,17.6-31.7,10.4,6.3,17.6,16.2,17.6,31.7v36.2Zm42-92.7H329.2a.43.43,0,0,0-.4.4v24.1a.52.52,0,0,0,.2.4c10.3,6.4,17.4,16.2,17.4,31.6v21c0,9.2-4.2,17.2-10.4,21a.52.52,0,0,0-.2.4v4.8a.46.46,0,0,0,.5.4H441.4a.43.43,0,0,0,.4-.4v-4.8a.52.52,0,0,0-.2-.4c-6.1-3.8-10.3-11.8-10.3-21v-21c0-15.4,7.1-25.2,17.4-31.6a.52.52,0,0,0,.2-.4V193a.66.66,0,0,0-.5-.4",
    transform: "translate(-51.2 -192.6)",
    style: {
      fill: "#89c540"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.1,
    y: 3.6,
    width: 112.9,
    height: 97,
    style: {
      fill: "url(#linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "25.5 104.1 4.2 67.5 4.2 104.1 0 104.1 0 59.1 4.2 59.1 25.7 96.1 25.7 59.1 29.9 59.1 29.9 104.1 25.5 104.1",
    style: {
      fill: "#006a56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,265.8c0-10.1,6.4-15.1,15.6-15.1,6.4,0,10.9,2.7,13.2,7l-3.2,1.6c-1.8-3.1-5.3-4.8-9.8-4.8-6.8,0-11.6,3.7-11.6,11.3v16.5c0,7.7,4.8,11.3,11.6,11.3,4.4,0,7.9-1.7,9.8-4.8l3.2,1.6c-2.3,4.4-6.8,7.1-13.2,7.1-9.2,0-15.6-5-15.6-15.1Z",
    transform: "translate(-51.2 -192.6)",
    style: {
      fill: "#006a56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,272.3c5.4,0,8.4-3,8.4-8.7,0-4.5-2.9-8.1-8.3-8.1h-12v16.8ZM130.3,293h13.1c5.4,0,8.4-3,8.4-8.7,0-4.4-2.9-8.1-8.3-8.1H130.4V293Zm12.8-41.3c7.5,0,11.7,5.3,11.7,11.5,0,5.5-2.1,9.2-6,10.9,4.6,1.5,7.1,5.7,7.1,10.5,0,7.9-4.3,12.2-11.8,12.2H126v-45h17.1Z",
    transform: "translate(-51.2 -192.6)",
    style: {
      fill: "#006a56"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.5 104.1 255.5 59.1 259.9 57.3 259.9 104.1 255.5 104.1",
    style: {
      fill: "#006a56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4,304.4a2.54,2.54,0,0,1-2.6,2.7,2.57,2.57,0,0,1-2.7-2.7,2.49,2.49,0,0,1,2.7-2.6,2.47,2.47,0,0,1,2.6,2.6",
    transform: "translate(-51.2 -192.6)",
    style: {
      fill: "#006a56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.9,304.4a2.54,2.54,0,0,1-2.6,2.7,2.57,2.57,0,0,1-2.7-2.7,2.49,2.49,0,0,1,2.7-2.6,2.47,2.47,0,0,1,2.6,2.6",
    transform: "translate(-51.2 -192.6)",
    style: {
      fill: "#006a56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,255.7l-1-2.3a2.1,2.1,0,0,1,1.2-2.8,2.52,2.52,0,0,1,2.4.2l.4-1.4a4,4,0,0,0-3.8-.4,3.7,3.7,0,0,0-2.2,5.2l1,2.3-1.3.6-.9,2.2,9.1-3.8v-1.9Z",
    transform: "translate(-51.2 -192.6)",
    style: {
      fill: "#006a56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.3,251.7v35.7a5.8,5.8,0,0,1-5.8,5.8h-3.2V259.7l-4.4,1.8v31.7h-3.3l-1.4,3.5h12.5a10,10,0,0,0,10-10V249.8Z",
    transform: "translate(-51.2 -192.6)",
    style: {
      fill: "#006a56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.8,293.2h-2.4c-4.8-.4-8.5-2.5-8.5-8.1a10.57,10.57,0,0,1,1.1-5,8.12,8.12,0,0,1,7.4-3.9,14.92,14.92,0,0,1,2.1.2c.1,0,.2.1.3.1v16.7Zm-.5-33.5c-6.6,0-11.3,2.8-13.6,7.3l3.3,1.6c1.9-3.2,5.5-5,10-5,7,0,12,3.8,12,11.8V289a4.23,4.23,0,0,1-4.2,4.2H257V274.4a12.25,12.25,0,0,0-4.2-1.4,19.48,19.48,0,0,0-2.5-.2,14.56,14.56,0,0,0-5.2.9,8.86,8.86,0,0,0-1.7.8c-.1.1-.3.1-.4.2h0c-3,1.9-5,5.4-5,10.3v.3c0,3.7,1.1,6.3,3,8.1h-7a5.8,5.8,0,0,1-5.8-5.8V250.1l-4.4,1.8v35.7c0,3.2-1.5,5.8-4.7,5.8-1.9,0-3.2-2.2-4.4-4.2l-12.9-25.7-1.8-3.6a15.08,15.08,0,0,0-4.3,4.4,21.72,21.72,0,0,0-3.3,7.2c-.4,2.5-1.2,5.8,2.6,12.8l5.2,9H182.5c-5.3-.1-7.2-3.9-7.2-8.9a17.49,17.49,0,0,1,2.6-9l-2.5-1.7a22,22,0,0,0-3.5,11.8c0,6.5,3.3,11.4,10.8,11.4h23.8l-7.3-12.5a49.35,49.35,0,0,1-2.4-5.8,14.46,14.46,0,0,1-.7-4.7,12.4,12.4,0,0,1,2.8-7L209.1,287c3.1,6,4.4,9.9,10,9.9a8.62,8.62,0,0,0,6.9-3.7,10,10,0,0,0,7.7,3.7H261a7.17,7.17,0,0,0,7.2-7.2V275.6c.1-10.7-6.5-15.9-15.9-15.9",
    transform: "translate(-51.2 -192.6)",
    style: {
      fill: "#006a56"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhli);
export default __webpack_public_path__ + "static/media/ahli.4f3894312a363c190184d6ec662ade67.svg";
export { ForwardRef as ReactComponent };